import { useTranslation } from 'next-i18next/pages'

import {
  StyledPercentageDiscountContainer,
  StyledPercentageDiscountHeading,
  StyledPercentageDiscountSubheading,
  StyledPercentageDiscountTextContainer,
  StyledPercentageDiscountWrapper,
} from 'sections/subscription/PromoImage/PromoImage.Styled'
import { getImageProps } from 'utils/images'

type Props = {
  discountPercentage: number
}

export const PromoDiscountPercentage = ({ discountPercentage }: Props) => {
  const { t } = useTranslation()

  return (
    <StyledPercentageDiscountWrapper>
      <StyledPercentageDiscountContainer>
        <img
          alt="Subscription image"
          {...getImageProps('shared', 'subscription', 'promoDiscountBlue')}
        />
        <StyledPercentageDiscountTextContainer>
          <StyledPercentageDiscountHeading>
            {t('paywall_x_percent_off', {
              0: discountPercentage,
            })}
          </StyledPercentageDiscountHeading>
          <StyledPercentageDiscountSubheading>
            {t('promo_sweat30_title')}
          </StyledPercentageDiscountSubheading>
        </StyledPercentageDiscountTextContainer>
      </StyledPercentageDiscountContainer>
    </StyledPercentageDiscountWrapper>
  )
}
